import { render, staticRenderFns } from "./activeVip.vue?vue&type=template&id=635b60c8&scoped=true&"
import script from "./activeVip.vue?vue&type=script&lang=js&"
export * from "./activeVip.vue?vue&type=script&lang=js&"
import style0 from "./activeVip.vue?vue&type=style&index=0&id=635b60c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635b60c8",
  null
  
)

export default component.exports